import React, { useEffect, useState, useRef } from 'react';
import { useMutation } from 'react-query';
import { RenderIf } from 'utilities/helpers';
import {
  useDeleteMixtureIngredient,
  useDeleteRecipeIngredient,
  useFetchRecipeMixtures,
  useFetchRecipeProductGroups,
  useFetchSingleMixture,
  useFetchSingleRecipe
} from 'hooks/recipes/useRecipesHook';
import { client } from 'utilities/db';
import { allUnits, getBranchId, getLocationId } from 'utilities/helpers/auth';
import { CustomAccordion } from '../update';
import { ModalComponent } from '../../../components/modal';
import { ThemeTabs } from 'components/tabs';
import { SelectDropdown } from 'components/selectdropdown';
import { TextField, TextFieldReffed } from 'components/input';
import { TextArea } from 'components/textarea';
import { CheckboxField } from 'components/checkbox';
import { Button } from 'components/button';
import { Toasts } from 'components/toasts';
import { Ikon } from 'assets/icons';
import styles from './index.module.css';
import { useStore } from 'store';
import { Row } from 'layouts/container';
import { DateInput } from 'rsuite';
import { useLocation, useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

// Utility to convert date string to hh:mm
function toHHMM(val) {
  if (!val) return '';
  // If already in hh:mm format
  if (/^\d{2}:\d{2}$/.test(val)) return val;
  // Try to parse as date
  const d = new Date(val);
  if (!isNaN(d.getTime())) {
    const hh = String(d.getHours()).padStart(2, '0');
    const mm = String(d.getMinutes()).padStart(2, '0');
    return `${hh}:${mm}`;
  }
  return '';
}

export const AddRecipePage = ({
  modifier,
  onChangeStep = () => {},
  isMixture,
  selectedData
}) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const singleMixtureDetail = useLocation()?.state;

  console.log('isMixture: ', isMixture, id, singleMixtureDetail);

  const {
    data: fetchedRecipe = {},

    isLoading: fetchedRecipeLoading,
    refetch
  } = useFetchSingleRecipe(!isMixture ? id : null);

  console.log('🚀 ~ fetchedRecipe:', fetchedRecipe);

  const {
    data: fetchedMixture = {},
    isLoading: fetchedMixtureLoading,
    refetch: refetchMixture
  } = useFetchSingleMixture(isMixture ? id : null);

  console.log('fetchedMixture: ', fetchedMixture);

  const { user, branch } = useStore((state) => state);

  const recipePermission = user?.role?.permissions?.find(
    (permission) =>
      permission?.slug === 'recipe_engineering' &&
      permission?.module_slug === 'recipes'
  );

  const branchId = branch?.id;
  const locationId = user?.brand?.id;
  const [search, setSearch] = useState('');
  const [stepsModal, setStepsModal] = useState(false);
  const [bulkModal, setBulkModal] = useState(false);
  const [recipeSteps, setRecipeSteps] = useState([]);
  const [unit, setUnit] = useState('');
  const [totalQuantity, setTotalQuantity] = useState('');
  const [servingUnit, setServingUnit] = useState('');
  const [servingQuantity, setServingQuantity] = useState('');
  const [isSubmit, setIsSubmit] = useState(false);
  const [isBulk, setIsBulk] = useState(false);
  const { data } = useFetchRecipeProductGroups(branchId);
  const { data: mixturesData } = useFetchRecipeMixtures(branchId);
  const [selectedIngredients, setselectedIngredients] = useState([]);
  const [cookingTime, setCookingTime] = useState('');
  const [mixtureName, setMixtureName] = useState('');
  const [isEdit, setIsEdit] = useState(false);
  const [unitDropdownIndex, setUnitDropdownIndex] = useState(null);
  const { mutate, isLoading, isSuccess, isError, error } = useMutation(
    (userData) => {
      return client.post(isMixture ? '/mixture/add' : `/recipe/add`, userData);
    }
  );
  const addStepInput = useRef();

  const { mutate: deleteIngredient, error: deleteIngredientError } =
    useDeleteRecipeIngredient();

  const {
    mutate: deleteMixtureIngredient,
    error: deleteMixtureIngredientError
  } = useDeleteMixtureIngredient();

  const {
    mutate: updateRecipe,
    isLoading: updateRecipeLoading,
    isSuccess: updateIsSuccess,
    isError: updateIsError,
    error: updateError
  } = useMutation((userData) => {
    return client.post(
      isMixture
        ? `/mixture/update-mixture/${userData?.id}`
        : `/recipe/update-recipe/${userData?.id}`,
      userData
    );
  });

  useEffect(() => {
    if (Object.keys(selectedData).length > 0) {
      if (isMixture) {
        const { mixture_name = '', MixtureRecipeModel = [] } = selectedData;
        setIsEdit(true);
        setselectedIngredients(MixtureRecipeModel);
        setMixtureName(mixture_name);
        return;
      }
      const {
        recipe = {},
        recipeIngredients = [],
        allergens,
        // this will be the chart data
        productHealthFactor = [],
        productNutrientsDetails = []
      } = selectedData;
      setRecipeSteps(recipe?.steps ? JSON.parse(recipe?.steps) : []);
      setUnit(recipe?.total_quantity?.unit || '');
      setTotalQuantity(recipe?.total_quantity?.quantity || '');
      setServingUnit(recipe?.serving_quantity?.unit || '');
      setServingQuantity(recipe?.serving_quantity?.quantity || '');
      setselectedIngredients(recipeIngredients);
      setCookingTime(recipe?.cooking_time || '');
      setIsEdit(true);
      if (recipe?.total_quantity?.quantity) {
        setIsBulk(true);
      }
    }
  }, [selectedData]);

  // Prefill for mixture update
  useEffect(() => {
    if (
      isMixture &&
      id &&
      fetchedMixture &&
      fetchedMixture.MixtureRecipeModel
    ) {
      setMixtureName(fetchedMixture.mixture_name || '');
      setselectedIngredients(
        fetchedMixture.MixtureRecipeModel.map((ing) => {
          return {
            ...ing,
            type: ing?.ProductModel?.product_name,
            product_id: ing?.ProductModel?.id,
            child_mixture_id: ing?.ChildMixtureModel?.id,
            product_group_id: null,
            type: ing?.ProductModel?.product_name
              ? 'RAW'
              : ing?.ChildMixtureModel?.mixture_name
              ? 'MIXTURE'
              : 'PRODUCT_GROUP',
            id: ing.id,
            name:
              ing?.ProductModel?.product_name ||
              ing?.ChildMixtureModel?.mixture_name ||
              'Mixture'
          };
        })
      );
    }
  }, [isMixture, id, fetchedMixture]);

  const createNewRecipe = () => {
    console.log('🚀 ~ recipes ~ modifier:', fetchedRecipe?.modifiers);
    setIsSubmit(true);
    if (
      isBulk &&
      (totalQuantity === '' || unit === '' || servingQuantity === '')
    )
      return;
    // Validate all modifier forms
    const recipes = fetchedRecipe?.modifiers?.map((modifier) => {
      console.log('🚀 ~ recipes ~ modifier:', modifier);

      const form = modifierFormData[modifier.id] || {};
      return {
        recipe_name: modifier.modifier_name,
        menu_item_id:
          modifier.MenuItemModel?.id ||
          modifier.menu_item_id ||
          modifier.menuItemId ||
          null,
        modifier_group_id: modifier.ModifierGroupModel?.id,
        modifier_id: modifier.id,
        cooking_time: toHHMM(form.cookingTime),
        ingredients: (form.selectedIngredients || []).map((item) => ({
          unit: item?.unit,
          quantity: item?.quantity,
          product_id: item?.type?.toUpperCase() === 'RAW' ? item?.id : null,
          mixture_id: item?.type?.toUpperCase() === 'MIXTURE' ? item?.id : null,
          product_group_id:
            item?.type?.toUpperCase() === 'PRODUCT_GROUP' ? item?.id : null,
          ingredient_type: item?.type?.toUpperCase()
        })),
        is_bulk: form.isBulk || false,
        total_quantity: {
          quantity: form.isBulk ? form.totalQuantity : null,
          unit: form.isBulk ? form.unit : null
        },
        serving_quantity: {
          quantity: form.isBulk ? form.servingQuantity : null,
          unit: form.isBulk ? form.unit : null
        },
        steps: form.recipeSteps || []
      };
    });
    const payload = {
      brand_id: locationId,
      branch_id: branchId,
      recipes
    };
    // if (isEdit) {
    //   updateRecipe(payload);
    //   return;
    // }
    mutate(payload);
  };
  const onChangeIngredients = (val) => {
    if (isMixture) {
      const same = selectedIngredients?.find(
        (item) =>
          item.id === val.id ||
          item?.ProductModel?.id === val?.id ||
          item?.MixtureModel?.id === val?.id
      )?.id;
      if (same) return;
      const ing = [...selectedIngredients];
      ing.push(val);
      setselectedIngredients(ing);
      return;
    }
    // For recipe (not mixture), update modifierFormData
    const same = (
      modifierFormData[selectedModifierId]?.selectedIngredients || []
    ).find(
      (item) =>
        item.id === val.id ||
        item?.ProductModel?.id === val?.id ||
        item?.MixtureModel?.id === val?.id
    )?.id;
    if (same) return;
    const ing = [
      ...(modifierFormData[selectedModifierId]?.selectedIngredients || [])
    ];
    ing.push(val);
    updateIngredients(ing);
  };
  // const removeIngredeint = (val) => {
  //   const ing = [...selectedIngredients];
  //   setselectedIngredients(ing?.filter((item) => item?.id !== val?.id));
  //   if (isMixture) {
  //     deleteMixtureIngredient(val?.id);
  //     return;
  //   }
  //   deleteIngredient(val.id);
  // };

  // const onChangeQuantity = (quantity, id) => {
  //   const ing = [...selectedIngredients];
  //   ing[id] = { ...ing[id], quantity };
  //   setselectedIngredients(ing);
  // };

  // const onChangeUnit = (unit, id) => {
  //   const ing = [...selectedIngredients];
  //   ing[id] = { ...ing[id], unit };
  //   setselectedIngredients(ing);
  // };

  useEffect(() => {
    if (isSuccess) {
      // onChangeStep(1);
      if (isMixture) {
        Toasts.success('Mixture added successfully');
        onChangeStep(1);
        navigate('/recipe-engineering');
      } else {
        Toasts.success('Recipe addedd successfully');
        navigate('/recipe-engineering');
      }
    }
  }, [isSuccess]);
  useEffect(() => {
    if (updateIsSuccess) {
      window.location.reload();
    }
  }, [updateIsSuccess]);

  useEffect(() => {
    if (isSuccess) {
      Toasts.error(error?.response?.data?.message);
    }
  }, [isError]);

  useEffect(() => {
    if (deleteIngredientError) {
      Toasts.error(deleteIngredientError?.response?.data?.message);
    }
    if (deleteMixtureIngredientError) {
      Toasts.error(deleteMixtureIngredientError?.response?.data?.message);
    }
  }, [deleteIngredientError, deleteMixtureIngredientError]);

  const onChangeSteps = (content, index) => {
    if (isMixture) {
      const allSteps = [...recipeSteps];
      allSteps[index] = { step: allSteps[index]?.step, content };
      setRecipeSteps(allSteps);
      return;
    }
    // For recipe (not mixture), update modifierFormData
    const allSteps = [...(currentFormData.recipeSteps || [])];
    allSteps[index] = { step: allSteps[index]?.step, content };
    updateRecipeSteps(allSteps);
  };

  // let kksteps = [];

  const onPressEnterKeyAddNewStep = (content) => {
    if (isMixture) {
      setRecipeSteps((prevSteps) => {
        const newStep = {
          step: prevSteps.length + 1,
          content
        };
        return [...prevSteps, newStep];
      });
      return;
    }
    // For recipe (not mixture), update modifierFormData
    const prevSteps = currentFormData.recipeSteps || [];
    const newStep = {
      step: prevSteps.length + 1,
      content
    };
    updateRecipeSteps([...prevSteps, newStep]);
  };

  const removeStep = (index) => {
    if (isMixture) {
      const steps = [...recipeSteps];
      const filteredSteps = steps.filter((item, i) => i !== index);
      // Renumber the steps
      const renumberedSteps = filteredSteps.map((step, i) => ({
        ...step,
        step: i + 1
      }));
      setRecipeSteps(renumberedSteps);
    } else {
      // For recipe (not mixture), update modifierFormData
      const currentSteps = currentFormData.recipeSteps || [];
      const filteredSteps = currentSteps.filter((item, i) => i !== index);
      // Renumber the steps
      const renumberedSteps = filteredSteps.map((step, i) => ({
        ...step,
        step: i + 1
      }));
      updateRecipeSteps(renumberedSteps);
    }
  };

  const panelRaw = () => {
    return (
      <>
        <div className={styles.accList}>
          {data
            ?.filter((item) =>
              item?.group_name?.toLowerCase()?.includes(search?.toLowerCase())
            )
            ?.map((item, i) => (
              <React.Fragment key={i}>
                <CustomAccordion
                  group={item.group_name}
                  products={item?.Products?.map((data) => ({
                    name: data?.product_name || data?.mixture_name,
                    id: data?.id || data?.MixtureModel?.id,
                    quantity: '',
                    type: 'raw',
                    ...(data?.ingredient_type === 'MIXTURE'
                      ? data?.MixtureModel
                      : data),
                    unit: ''
                  }))}
                  handleClick={onChangeIngredients}
                  productGroup={item}
                />
              </React.Fragment>
            ))}
        </div>
      </>
    );
  };

  const panelMixtures = () => {
    return (
      <>
        <div className={styles.accList}>
          {mixturesData
            ?.filter((item) => item?.mixture_name?.includes(search))
            ?.map((item, i) => (
              <React.Fragment key={i}>
                <CustomAccordion
                  group={item.mixture_name}
                  products={[]}
                  onClickHeading={() =>
                    onChangeIngredients({
                      ...item,
                      quantity: '',
                      unit: '',
                      type: 'MIXTURE',
                      name: item?.mixture_name,
                      id: item?.id
                    })
                  }
                  isMixture
                />
              </React.Fragment>
            ))}
        </div>
      </>
    );
  };

  useEffect(() => {
    addStepInput?.current?.addEventListener('keypress', handleEnterKeyPress);
    return () => {
      addStepInput?.current?.removeEventListener(
        'keypress',
        handleEnterKeyPress
      );
    };
  }, []);

  // useEffect(() => {
  //   setRecipeStepIndex(recipeSteps?.length + 1);
  // }, [recipeSteps]);

  const handleEnterKeyPress = (event) => {
    if (event?.key === 'Enter' && addStepInput?.current?.value !== '') {
      event?.preventDefault();
      onPressEnterKeyAddNewStep(addStepInput.current.value);
      addStepInput.current.value = '';
    }
  };

  const [selectedModifierId, setSelectedModifierId] = useState(null);
  const [modifierFormData, setModifierFormData] = useState({});

  // When fetchedRecipe.modifiers loads, set default selectedModifierId
  useEffect(() => {
    if (
      !isMixture &&
      fetchedRecipe?.modifiers?.length > 0 &&
      selectedModifierId === null
    ) {
      setSelectedModifierId(fetchedRecipe.modifiers[0].id);
    }
  }, [fetchedRecipe, isMixture, selectedModifierId]);

  // Handler for switching modifier tabs
  const handleModifierTabClick = (modifier) => {
    setSelectedModifierId(modifier.id);
    // If no data exists for this modifier, initialize it
    setModifierFormData((prev) => {
      if (prev[modifier.id]) return prev;
      return {
        ...prev,
        [modifier.id]: {
          cookingTime: '',
          selectedIngredients: [],
          recipeSteps: [],
          isBulk: false,
          totalQuantity: '',
          unit: '',
          servingQuantity: ''
        }
      };
    });
  };

  // Helper to get/set current modifier's form data
  const currentFormData = modifierFormData[selectedModifierId] || {
    cookingTime: '',
    selectedIngredients: [],
    recipeSteps: [],
    isBulk: false,
    totalQuantity: '',
    unit: '',
    servingQuantity: ''
  };

  // Update a field in the current modifier's form data
  const updateCurrentFormData = (field, value) => {
    setModifierFormData((prev) => ({
      ...prev,
      [selectedModifierId]: {
        ...prev[selectedModifierId],
        [field]: value
      }
    }));
  };

  // Update selectedIngredients array
  const updateIngredients = (ingredients) => {
    setModifierFormData((prev) => ({
      ...prev,
      [selectedModifierId]: {
        ...prev[selectedModifierId],
        selectedIngredients: ingredients
      }
    }));
  };

  // Update recipeSteps array
  const updateRecipeSteps = (steps) => {
    setModifierFormData((prev) => ({
      ...prev,
      [selectedModifierId]: {
        ...prev[selectedModifierId],
        recipeSteps: steps
      }
    }));
  };

  useEffect(() => {
    if (!isMixture && fetchedRecipe?.modifiers?.length > 0) {
      const newFormData = {};
      fetchedRecipe.modifiers.forEach((modifier) => {
        const recipe = modifier.RecipeModel;
        if (recipe) {
          newFormData[modifier.id] = {
            cookingTime: toHHMM(recipe.cooking_time),
            recipeSteps: recipe.steps ? JSON.parse(recipe.steps) : [],
            selectedIngredients: (recipe.RecipeIngredientModel || []).map(
              (ing) => {
                let type = 'RAW';
                let product_id = ing.product_id;
                let mixture_id = null;
                if (ing.ingredient_type === 'MIXTURE') {
                  type = 'MIXTURE';
                  product_id = null;
                  mixture_id = ing.mixture_id;
                }
                return {
                  ...ing,
                  unit: ing.unit,
                  quantity: ing.quantity,
                  product_id,
                  mixture_id,
                  ingredient_type: ing.ingredient_type,
                  // Attach product info for UI
                  ProductModel: ing.ProductModel || ing?.MixtureModel || null,
                  name:
                    ing.ProductModel?.product_name ||
                    ing.MixtureModel?.mixture_name ||
                    '',
                  id: ing.ProductModel?.id || ing.MixtureModel?.id || ing.id,
                  type
                };
              }
            ),
            isBulk: false, // set as needed
            totalQuantity: '', // set as needed
            unit: '', // set as needed
            servingQuantity: '' // set as needed
          };
        }
      });
      if (Object.keys(newFormData)?.length > 0) {
        setIsEdit(true);
      }
      setModifierFormData((prev) => ({ ...prev, ...newFormData }));
    }
  }, [fetchedRecipe, isMixture]);

  console.log('currentFormData.cookingTime:', currentFormData.cookingTime);

  // Mixture save logic
  const saveMixture = async () => {
    // Mixture update flow
    if (isMixture && id && fetchedMixture) {
      const payload = {
        mixture_name: mixtureName,
        id: Number(id),
        ingredients: selectedIngredients.map((item) => ({
          unit: item.unit,
          quantity: item.quantity,
          product_id: item.type === 'RAW' ? item.product_id || item.id : null,
          child_mixture_id:
            item.type === 'MIXTURE' ? item.child_mixture_id || item.id : null,
          product_group_id: null,
          ingredient_type: item.type,
          id: item.id
        }))
      };
      try {
        await client.post(`/mixture/update-mixture/${id}`, payload);
        Toasts.success('Mixture updated successfully');
        // onChangeStep(1);
        navigate('/recipe-engineering');
      } catch (err) {
        Toasts.error(
          err?.response?.data?.message || 'Failed to update mixture'
        );
      }
      return;
    }
    // Mixture add flow (existing logic)
    const payload = {
      mixture_name: mixtureName,
      expire_time: '', // Add logic if you want to support expiry
      expiry_unit: '', // Add logic if you want to support expiry
      brand_id: locationId,
      branch_id: branchId,
      ingredients: selectedIngredients.map((item) => {
        if ((item.type || item.ingredient_type)?.toUpperCase() === 'MIXTURE') {
          return {
            unit: item.unit,
            quantity: item.quantity,
            product_id: null,
            child_mixture_id: item.id,
            mixture_id: null,
            product_group_id: null,
            ingredient_type: 'MIXTURE'
          };
        }
        // RAW
        return {
          unit: item.unit,
          quantity: item.quantity,
          product_id: item.id,
          child_mixture_id: null,
          mixture_id: null,
          product_group_id: null,
          ingredient_type: 'RAW'
        };
      })
    };
    // Call your mixture API here, e.g.:
    // saveMixtureAPI(payload);
    console.log('Mixture payload:', payload);
    mutate(payload);
  };

  return (
    <>
      <article className={styles.article}>
        <div className="flex item_space_btn pt_10">
          <div>
            <Row alignItems={'center'} gap={8}>
              {/* <div>
                <Button
                  onClick={() => {
                    onChangeStep(1);
                  }}
                  style={{
                    whiteSpace: 'nowrap',
                    padding: '10px 10px',
                    width: 'auto',
                    background: '#FFFFFF',
                    boxShadow: '0px 0px 4px #D1D1D3',
                    borderRadius: '6px',
                    gap: '4px',
                    fontWeight: '500',
                    color: '#474747',
                    height: 'auto'
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    width={16}
                    height={16}
                    strokeWidth="1.5"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18"
                    />
                  </svg>
                </Button>
              </div> */}
              <div>
                <h2
                  style={{
                    fontSize: '24px',
                    fontWeight: '800',
                    margin: '20px 0px 0px 0px'
                  }}
                >
                  {isMixture
                    ? 'Add Mixture'
                    : fetchedRecipe?.menuItem?.menu_item_name}
                </h2>
              </div>
            </Row>
          </div>
          <div className="flex item_vcenter gap_10">
            <Button
              onClick={() => {
                // if (isEdit) {
                //   window.location.reload();
                //   return;
                // }
                // onChangeStep(1);
                if (typeof onChangeStep === 'function') {
                  onChangeStep(1);
                }
                navigate('/recipe-engineering');
              }}
              type="button"
              label={'Cancel'}
              color={'outline-lite'}
            />
            <Button
              onClick={() => {
                if (isMixture) {
                  saveMixture();
                  return;
                }
                setBulkModal(true);
              }}
              type="button"
              label={'Save'}
              color={'bg-button'}
              isLoading={isLoading || updateRecipeLoading}
              disabled={recipePermission?.access?.create === false}
            />
          </div>
        </div>
        <div className={styles.r1Bx}>
          <div className={styles.left}>
            <div>
              <RenderIf isTrue={isMixture}>
                <TextField
                  name="mixture_name"
                  id="mixture_name"
                  type="text"
                  label={``}
                  placeholder="Mixture name"
                  onChange={(val) => setMixtureName(val.target.value)}
                  value={mixtureName}
                />
              </RenderIf>
              <RenderIf isTrue={!isMixture}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '8px',
                    marginBottom: '16px',
                    width: '100%',
                    overflowX: 'auto',
                    scrollbarWidth: 'none'
                  }}
                >
                  {fetchedRecipe?.modifiers?.map((modifier) => (
                    <button
                      key={modifier.id}
                      type="button"
                      onClick={() => handleModifierTabClick(modifier)}
                      style={{
                        padding: '10px 20px',
                        border:
                          selectedModifierId === modifier.id
                            ? '2px solid #a561d8'
                            : '1px solid #a561d8',
                        borderRadius: '10px 10px 10px 10px',
                        background:
                          selectedModifierId === modifier.id
                            ? '#f0f6ff'
                            : '#fff',
                        color:
                          selectedModifierId === modifier.id
                            ? '#a561d8'
                            : '#333',
                        fontWeight:
                          selectedModifierId === modifier.id ? 700 : 400,
                        outline: 'none',
                        cursor: 'pointer',
                        transition: 'all 0.2s',
                        boxShadow:
                          selectedModifierId === modifier.id
                            ? '0 2px 8px rgba(0,123,255,0.08)'
                            : 'none'
                      }}
                    >
                      {modifier?.modifier_name}
                    </button>
                  ))}
                </div>
              </RenderIf>
            </div>
            <div>
              <ThemeTabs
                tabs={[{ label: 'Raw' }, { label: 'Mixtures' }]}
                panels={[{ content: panelRaw() }, { content: panelMixtures() }]}
                isSearchFull={
                  <div className="mt_12">
                    <TextField
                      name="search"
                      id="search"
                      type="text"
                      placeholder="Search"
                      onChange={(val) => setSearch(val.target.value)}
                      value={search}
                    />
                  </div>
                }
              />
            </div>
            <div>
              <label>Prep time</label>
              <DateInput
                format="HH:mm"
                name="cookingTime"
                id="cookingTime"
                type="text"
                label="Prep time"
                placeholder="hh:mm"
                onChange={(val) => updateCurrentFormData('cookingTime', val)}
                value={currentFormData.cookingTime}
              />
            </div>
            {/* <TextField
              name="cookingTime"
              id="cookingTime"
              type="text"
              label="Prep time"
              placeholder="hh:mm"
              onChange={(val) => setCookingTime(val.target.value)}
              value={cookingTime}
            /> */}
          </div>
          <div className={styles.middle}>
            <div className={styles.formulaBx}>
              <h4>Formula</h4>
              <div className={styles.ingList}>
                {isMixture
                  ? selectedIngredients?.map((item, i) => (
                      <div className={styles.ingItem} key={i}>
                        <div>
                          <h6>
                            {item?.name ||
                              item?.ProductModel?.product_name ||
                              item?.MixtureModel?.mixture_name ||
                              item?.group_name ||
                              item?.ProductGroupModel?.group_name}
                          </h6>
                        </div>
                        <div>
                          <div>
                            <input
                              type="number"
                              name="quantity"
                              className={styles.inputQty}
                              id="quantity"
                              placeholder="0"
                              onChange={(val) => {
                                const updated = [...selectedIngredients];
                                updated[i] = {
                                  ...updated[i],
                                  quantity: val.target.value
                                };
                                setselectedIngredients(updated);
                              }}
                              value={item?.quantity}
                            />
                          </div>
                          <div className={styles.unitItem}>
                            <button
                              type="button"
                              className={styles.inputUnit}
                              onClick={() => {
                                if (
                                  unitDropdownIndex === null ||
                                  unitDropdownIndex !== i
                                ) {
                                  setUnitDropdownIndex(i);
                                } else {
                                  setUnitDropdownIndex(null);
                                }
                              }}
                            >
                              {item?.unit}
                            </button>
                            <RenderIf isTrue={unitDropdownIndex === i}>
                              <div className={styles.unitDropdownList}>
                                {allUnits
                                  ?.filter((unt) => unt !== '')
                                  ?.map((unt, idx) => (
                                    <button
                                      key={idx}
                                      type="button"
                                      className={styles.unitDropdownItem}
                                      onClick={() => {
                                        const updated = [
                                          ...selectedIngredients
                                        ];
                                        updated[i] = {
                                          ...updated[i],
                                          unit: unt?.toUpperCase()
                                        };
                                        setselectedIngredients(updated);
                                        setUnitDropdownIndex(null);
                                      }}
                                    >
                                      {unt}
                                    </button>
                                  ))}
                              </div>
                            </RenderIf>
                          </div>
                          <button
                            className={styles.buttonIng}
                            onClick={() => {
                              const updated = selectedIngredients.filter(
                                (ing) => ing?.id !== item?.id
                              );
                              setselectedIngredients(updated);
                            }}
                          >
                            <Ikon name={`closex`} />
                          </button>
                        </div>
                      </div>
                    ))
                  : currentFormData.selectedIngredients?.map((item, i) => (
                      <div className={styles.ingItem} key={i}>
                        <div>
                          <h6>
                            {item?.name ||
                              item?.ProductModel?.product_name ||
                              item?.MixtureModel?.mixture_name ||
                              item?.group_name ||
                              item?.ProductGroupModel?.group_name}
                          </h6>
                        </div>
                        <div>
                          <div>
                            <input
                              type="number"
                              name="quantity"
                              className={styles.inputQty}
                              id="quantity"
                              placeholder="0"
                              onChange={(val) => {
                                const updated = [
                                  ...currentFormData.selectedIngredients
                                ];
                                updated[i] = {
                                  ...updated[i],
                                  quantity: val.target.value
                                };
                                updateIngredients(updated);
                              }}
                              value={item?.quantity}
                            />
                          </div>
                          <div className={styles.unitItem}>
                            <button
                              type="button"
                              className={styles.inputUnit}
                              onClick={() => {
                                if (
                                  unitDropdownIndex === null ||
                                  unitDropdownIndex !== i
                                ) {
                                  setUnitDropdownIndex(i);
                                } else {
                                  setUnitDropdownIndex(null);
                                }
                              }}
                            >
                              {item?.unit}
                            </button>
                            <RenderIf isTrue={unitDropdownIndex === i}>
                              <div className={styles.unitDropdownList}>
                                {allUnits
                                  ?.filter((unt) => unt !== '')
                                  ?.map((unt, idx) => (
                                    <button
                                      key={idx}
                                      type="button"
                                      className={styles.unitDropdownItem}
                                      onClick={() => {
                                        const updated = [
                                          ...currentFormData.selectedIngredients
                                        ];
                                        updated[i] = {
                                          ...updated[i],
                                          unit: unt?.toUpperCase()
                                        };
                                        updateIngredients(updated);
                                        setUnitDropdownIndex(null);
                                      }}
                                    >
                                      {unt}
                                    </button>
                                  ))}
                              </div>
                            </RenderIf>
                          </div>
                          <button
                            className={styles.buttonIng}
                            onClick={() => {
                              const updated =
                                currentFormData.selectedIngredients.filter(
                                  (ing) => ing?.id !== item?.id
                                );
                              updateIngredients(updated);
                            }}
                          >
                            <Ikon name={`closex`} />
                          </button>
                        </div>
                      </div>
                    ))}
              </div>
            </div>
          </div>
          <RenderIf isTrue={!isMixture}>
            <div className={styles.right}>
              {/* <div>
              <TextFieldReffed
                refEl={addStepInput}
                type="text"
                name="description"
                id="description"
                label={''}
                placeholder={'Steps for Recipe'}
              />
            </div> */}
              <h4>Steps for Recipe</h4>
              <div className={styles.stepList}>
                {isMixture
                  ? recipeSteps?.map((item, index) => (
                      <div key={index} className={styles.stepItem}>
                        <div>{item?.step}</div>
                        <div>{item?.content}</div>
                        <div></div>
                      </div>
                    ))
                  : currentFormData.recipeSteps?.map((item, index) => (
                      <div key={index} className={styles.stepItem}>
                        <div>{item?.step}</div>
                        <div>{item?.content}</div>
                        <div></div>
                      </div>
                    ))}
              </div>
            </div>
          </RenderIf>
        </div>
        <RenderIf isTrue={!isMixture}>
          <Button
            onClick={() => {
              setStepsModal(true);
              if (
                !currentFormData.recipeSteps ||
                currentFormData.recipeSteps.length === 0
              ) {
                updateRecipeSteps([
                  {
                    step: 1,
                    content: ''
                  }
                ]);
              }
            }}
            type="button"
            label={'Steps'}
            color={'bg-button'}
          />
        </RenderIf>

        <RenderIf
          isTrue={
            !isMixture &&
            Array.isArray(fetchedRecipe?.modifiers) &&
            fetchedRecipe?.modifiers?.length > 0
          }
        >
          <div className={styles.nutritionSectionWrapper}>
            {fetchedRecipe?.modifiers?.map((modifier) => {
              const hasNutrients =
                Array.isArray(modifier.productNutrientsDetails) &&
                modifier.productNutrientsDetails.length > 0;
              const hasHealthFactor =
                Array.isArray(modifier.productHealthFactor) &&
                modifier.productHealthFactor.length > 0;
              if (!hasNutrients && !hasHealthFactor) return null;
              return (
                <div key={modifier.id} className={styles.nutritionCard}>
                  <h3 className={styles.nutritionModifierTitle}>
                    {modifier.modifier_name} Nutrition Facts
                  </h3>
                  <div className={styles.nutritionTablesRow}>
                    {/* Product Nutrients Details Table */}
                    {hasNutrients && (
                      <div className={styles.nutritionTableWrapper}>
                        <h4 className={styles.nutritionTableTitle}>
                          Nutrients per Serving
                        </h4>
                        <table className={styles.nutritionTable}>
                          <thead>
                            <tr>
                              <th>Nutrient</th>
                              <th>Value</th>
                              <th>Unit</th>
                            </tr>
                          </thead>
                          <tbody>
                            {modifier.productNutrientsDetails.map(
                              (nutrient, idx) => (
                                <tr key={idx}>
                                  <td>{nutrient.nutrientName}</td>
                                  <td>{nutrient.value}</td>
                                  <td>{nutrient.unitName}</td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </div>
                    )}
                    {/* Product Health Factor Table */}
                    {hasHealthFactor && (
                      <div className={styles.nutritionTableWrapper}>
                        <h4 className={styles.nutritionTableTitle}>
                          Health Factor
                        </h4>
                        <table className={styles.nutritionTable}>
                          <thead>
                            <tr>
                              <th>Nutrient</th>
                              <th>Value</th>
                              <th>Unit</th>
                              <th>% of Total</th>
                            </tr>
                          </thead>
                          <tbody>
                            {modifier.productHealthFactor.map((factor, idx) => (
                              <tr key={idx}>
                                <td>{factor.nutrientName}</td>
                                <td>{factor.value}</td>
                                <td>{factor.unitName}</td>
                                <td>{factor.percentage}%</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </RenderIf>
      </article>
      <ModalComponent
        modal={bulkModal}
        handleModal={() => setBulkModal(false)}
        modalMiddle={true}
      >
        <div className="modal_box1">
          <h6>
            <span className="ff_semi">Serving type</span>
          </h6>
          <div className="mt_10"></div>
          <CheckboxField
            checked={isBulk}
            onChange={(e) => setIsBulk(!isBulk)}
            id="bulk"
          >
            <strong>This serving is bulk quantity</strong>
          </CheckboxField>
          {isBulk && (
            <div className="grid grid_gap8">
              <div className="colxs6">
                <div className="mt_10"></div>
                <TextField
                  fieldSm
                  name="quantity"
                  id="quantity"
                  type="number"
                  placeholder="Quantity"
                  label={'Total quantity'}
                  onChange={(val) => setTotalQuantity(val.target.value)}
                  value={totalQuantity}
                  error={
                    isSubmit && isBulk && totalQuantity === ''
                      ? 'Total quantity is required'
                      : ''
                  }
                />
              </div>
              <div className="colxs6">
                <div className="mt_10"></div>
                <SelectDropdown
                  fieldSm
                  label="Unit"
                  data={[
                    { value: '', label: 'choose option' },
                    ...allUnits.map((item) => ({
                      value: item?.toUpperCase(),
                      label: item?.toUpperCase()
                    }))
                  ]}
                  onChange={(e) => setUnit(e.target.value)}
                  error={
                    isSubmit && isBulk && unit === ''
                      ? 'Total unit is required'
                      : ''
                  }
                  value={unit}
                />
              </div>
              <div className="colxs6">
                <div className="mt_10"></div>
                <TextField
                  name="servingQuantity"
                  id="servingQuantity"
                  type="number"
                  placeholder="Quantity"
                  label={'Serving quantity'}
                  onChange={(val) => setServingQuantity(val.target.value)}
                  value={servingQuantity}
                  error={
                    isSubmit && isBulk && servingQuantity === ''
                      ? 'Serving quantity is required'
                      : ''
                  }
                />
              </div>
              <div className="colxs6">
                <div className="mt_10"></div>
                {/* <SelectDropdown
                    label="Unit"
                    data={[
                      { value: '', label: 'choose option' },
                      ...allUnits.map((item) => ({
                        value: item?.toUpperCase(),
                        label: item?.toUpperCase()
                      }))
                    ]}
                    onChange={(e) => setUnit(e.target.value)}
                    error={
                      isSubmit && isBulk && unit === ''
                        ? 'Serving Unit is required'
                        : ''
                    }
                    value={unit}
                  /> */}
              </div>
            </div>
          )}
          <div className="flex item_vcenter item_hend mt_10">
            <div className="flex item_vcenter gap_16">
              <Button
                onClick={() => {
                  setBulkModal(false);
                  navigate('/recipe-engineering');
                }}
                type="button"
                label={'Cancel'}
                color={'outline-lite'}
              />
              <Button
                onClick={createNewRecipe}
                type="button"
                label={'Save'}
                color={'bg-button'}
                isLoading={isLoading}
              />
            </div>
          </div>
        </div>
      </ModalComponent>
      <ModalComponent
        modal={stepsModal}
        handleModal={() => setStepsModal(false)}
        modalMiddle={true}
      >
        <h6>
          <span className="ff_semi">Recipe steps</span>
        </h6>
        <div className={styles.modal_container}>
          <div className="modal_box2">
            <div style={{ marginTop: 16 }}></div>
            {isMixture
              ? recipeSteps?.map((item, i) => (
                  <React.Fragment key={i}>
                    <RenderIf isTrue={i !== 0}>
                      <div className="mt_10"></div>
                    </RenderIf>
                    <div className="flex item_vcenter item_space_btn">
                      <p>
                        <strong>Step {i + 1}</strong>
                      </p>
                      <button
                        className="ikonlink svg_w10"
                        color="danger"
                        onClick={() => removeStep(i)}
                      >
                        <Ikon closex />
                      </button>
                    </div>
                    <div style={{ marginTop: 4 }}></div>
                    <TextArea
                      name={`description_${i}`}
                      label={''}
                      rows="4"
                      placeholder={'Step details'}
                      key={i}
                      onChange={(e) => {
                        const allSteps = [...recipeSteps];
                        allSteps[i] = {
                          step: allSteps[i]?.step,
                          content: e.target.value
                        };
                        setRecipeSteps(allSteps);
                      }}
                      value={item?.content}
                    />
                  </React.Fragment>
                ))
              : currentFormData.recipeSteps?.map((item, i) => (
                  <React.Fragment key={i}>
                    <RenderIf isTrue={i !== 0}>
                      <div className="mt_10"></div>
                    </RenderIf>
                    <div className="flex item_vcenter item_space_btn">
                      <p>
                        <strong>Step {i + 1}</strong>
                      </p>
                      <button
                        className="ikonlink svg_w10"
                        color="danger"
                        onClick={() => removeStep(i)}
                      >
                        <Ikon closex />
                      </button>
                    </div>
                    <div style={{ marginTop: 4 }}></div>
                    <TextArea
                      name={`description_${i}`}
                      label={''}
                      rows="4"
                      placeholder={'Step details'}
                      key={i}
                      onChange={(e) => onChangeSteps(e.target.value, i)}
                      value={item?.content}
                    />
                  </React.Fragment>
                ))}
            <div className="flex item_hend mt_10">
              <button
                onClick={() =>
                  isMixture
                    ? setRecipeSteps([
                        ...recipeSteps,
                        { step: recipeSteps.length + 1, content: '' }
                      ])
                    : updateRecipeSteps([
                        ...currentFormData.recipeSteps,
                        {
                          step: currentFormData.recipeSteps.length + 1,
                          content: ''
                        }
                      ])
                }
                className="alink"
                color="primary"
              >
                + Add step
              </button>
            </div>
          </div>
        </div>
        <div className="flex item_vcenter item_hend mt_10">
          <div className="flex item_vcenter gap_16">
            <Button
              onClick={() => setStepsModal(false)}
              type="button"
              label={'Cancel'}
              color={'outline-lite'}
            />
            <Button
              onClick={() => setStepsModal(false)}
              type="button"
              label={'Save'}
              color={'bg-button'}
              isLoading={isLoading}
            />
          </div>
        </div>
      </ModalComponent>
    </>
  );
};
